import React from 'react'
/**
 * These are not cacheable and therefore not optimized.
 * But they work in cms server side rendering
 **/

const EthosLogoFancyS = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 971.997 180.498"
    {...props}
  >
    <title>ethos-logo-S</title>
    <path
      d="M902.169 180.71c42.42 0 69.828-21.018 69.828-53.55 0-30.5-21.438-41.532-56.034-49.428l-21.192-4.65c-19.08-4.218-29.424-9.12-29.424-22.944 0-14.094 13.134-23.2 33.462-23.2 18.966 0 35.658 7.044 45.942 19.362l22.008-17.69C954.645 15.51 933.273.21 899.583.21c-38.064 0-65.694 21.648-65.694 51.48 0 34.044 27.87 44.436 52.152 49.686l23.52 5.172c18.594 4.038 30.978 9.576 30.978 23.454 0 14.916-13.422 23.46-36.816 23.46-25.518 0-44.808-12.534-52.89-25.17l-24.15 17.388c12.438 17.046 38.64 35.028 75.486 35.028"
      fill="#054742"
    />
  </svg>
)

export default EthosLogoFancyS
